var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "discover-icon-Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "discover-icon-Icon/Discovery/24", fill: "#1A1A1A", fillRule: "nonzero" },
        React.createElement("path", { d: "M12 0c6.628 0 12 5.373 12 12s-5.372 12-12 12S0 18.627 0 12 5.372 0 12 0zm.75 1.526V3.25a.75.75 0 1 1-1.5 0V1.526C5.801 1.911 1.5 6.453 1.5 12c0 5.547 4.301 10.09 9.75 10.474V20.75a.75.75 0 1 1 1.5 0v1.724C18.2 22.089 22.5 17.547 22.5 12c0-5.547-4.3-10.089-9.75-10.474zm5.754 4.976l-3.889 7.778a.886.886 0 0 1-.028.051l.028-.051a.75.75 0 0 1-.14.195l.055-.062a.75.75 0 0 1-.041.048l-.015.014a.765.765 0 0 1-.194.14l-7.778 3.89c-.645.322-1.329-.362-1.006-1.007L9.385 9.72a.75.75 0 0 1 .028-.051l-.028.051a.75.75 0 0 1 .14-.195l-.055.062a.75.75 0 0 1 .041-.048l.014-.014a.764.764 0 0 1 .176-.13l7.797-3.9c.645-.322 1.329.362 1.006 1.007zm-8.243 4.819l-2.417 4.835 4.834-2.417-2.417-2.418zm5.895-3.477l-4.835 2.416 2.417 2.418 2.418-4.834z", id: "discover-icon-Combined-Shape" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/icons/Discover.svg